<ng-container *ngIf="authService.isLoggedIn">
    <popup-menu *ngIf="popupMenuConfig"
                [menuConfig]="popupMenuConfig" styleType="inherit"
                icon="user"
                iconSize="2x"
                (onSelect)="launchAction($event)"></popup-menu>
    <span class="sayHello" *ngIf="sayHello">{{sayHello}}</span>
</ng-container>